import React from 'react'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import CustomerService from './pages/customerService'
import WorkOrderList from './pages/workOrderList'
import WorkOrderSubmit from './pages/workOrderSubmit'
import MyWorkOrder from './pages/myWorkOrder'
import MyWorkOrderInfo from './pages/myWorkOrderInfo'
import CloseWin from './pages/closeWin'
import '@chatui/core/es/styles/index.less';
import "./App.css"
import './iconfont/iconfont.css'
import locales from './locales/'
import { entity } from './utils/entity';
import { IntlProvider } from 'react-intl'; /* react-intl imports */

const route = () => {
  if (!entity.ai) {
    return (
      <IntlProvider
        locale='zh'
        messages={locales.zh}
      >
        <BrowserRouter >
          <Switch>
            <Route exact path="/workOrderList" component={WorkOrderList} />
            <Route exact path="/workOrderSubmit" component={WorkOrderSubmit} />
            <Route exact path="/myWorkOrder" component={MyWorkOrder} />
            <Route exact path="/myWorkOrderInfo" component={MyWorkOrderInfo} />
            <Route exact path="/closeWin" component={CloseWin} />
            <Redirect to={{
              pathname: '/workOrderList',
              search: `${window.location.search}`,
            }} />
          </Switch>
        </BrowserRouter >
      </IntlProvider>
    );
  } else {
    return (
      <IntlProvider
        locale='zh'
        messages={locales.zh}
      >
        <BrowserRouter >
          <Switch>
            <Route exact path="/" component={CustomerService} />
            <Route exact path="/workOrderList" component={WorkOrderList} />
            <Route exact path="/workOrderSubmit" component={WorkOrderSubmit} />
            <Route exact path="/myWorkOrder" component={MyWorkOrder} />
            <Route exact path="/myWorkOrderInfo" component={MyWorkOrderInfo} />
            <Route exact path="/closeWin" component={CloseWin} />
            <Redirect to={{
              pathname: '/',
              search: `${window.location.search}`,
            }} />
          </Switch>
        </BrowserRouter >
      </IntlProvider>
    );
  }
};

export default route;
